import { RoleVO } from '../../vo/user/role.vo';
import { ProfileVO } from '../../vo/user/profile.vo';
import { Component, HostBinding } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'tooltip-component',
  template: ` <div class="custom-tooltip">
    <wiz-vgroup *ngIf="isProfile">
      <p>
        <span>{{ data.trsLabel }}: </span>
      </p>
      <ul>
        <li *ngFor="let role of roles">{{ role.code }} - {{ role.trsLabel }}</li>
      </ul>
    </wiz-vgroup>
    <p *ngIf="!isProfile">{{ data.trsLabel }}</p>
  </div>`,
  styles: [
    `
      :host {
        position: absolute;
        border: 1px solid var(--item-purple);
        overflow: hidden;
        pointer-events: none;
        opacity: 1;
        transition: opacity 1s;
        color: black;
        background-color: white;
      }

      :host.ag-tooltip-hiding {
        opacity: 0;
      }

      .custom-tooltip p {
        margin: 5px;
        white-space: nowrap;
      }

      .custom-tooltip p:first-of-type {
        font-weight: bold;
      }
    `,
  ],
})
export class CustomTooltip implements ITooltipAngularComp {
  @HostBinding('style.width') get tooltipWidth() {
    if (this.isProfile) {
      return '250px';
    } else {
      return '150px';
    }
  }

  public data: RoleVO | ProfileVO;

  private params: ITooltipParams;

  agInit(params: ITooltipParams): void {
    this.params = params;
    this.data = params.data;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  public get isProfile(): boolean {
    return this.data instanceof ProfileVO;
  }

  public get roles(): RoleVO[] {
    return (this.data as ProfileVO).rolesVO;
  }
}
